export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatDate = (dateString) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateShort = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

export const getStatusBadgeClass = (status) => {
  const statusLower = status?.toLowerCase();
  
  if (['approved', 'confirmed', 'completed', 'resolved', 'accepted'].includes(statusLower)) {
    return 'badge-success';
  }
  
  if (['pending', 'submitted', 'in_review', 'quoted', 'processing', 'open', 'in_progress'].includes(statusLower)) {
    return 'badge-warning';
  }
  
  if (['rejected', 'declined', 'cancelled', 'failed'].includes(statusLower)) {
    return 'badge-danger';
  }
  
  if (['resubmit'].includes(statusLower)) {
    return 'badge-info';
  }
  
  return 'badge-neutral';
};

export const formatStatusText = (status) => {
  return status?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};

export const truncateAddress = (address, start = 6, end = 4) => {
  if (!address) return '';
  if (address.length <= start + end) return address;
  return `${address.slice(0, start)}...${address.slice(-end)}`;
};

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};

export const downloadCSV = (data, filename) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};
